import Tippy from "@tippyjs/react";
import { ReactComponent as InfoIcon } from "../../../assets/Icon feather-info.svg";
import "./index.css";
import { MealOptions } from "../../single-property-view/roomData/roomDetailCard";

function PropertyCardToolTip({ meals = {} }) {
  if (!Object.values(meals).some((value) => value === true)) {
    return null;
  }

  return (
    <Tippy
      arrow={true}
      interactive={true}
      content={<MealOptions meals={meals} className="" />}
    >
      <InfoIcon className="tooltip-icon" />
    </Tippy>
  );
}

export default PropertyCardToolTip;
